module.exports = __webpack_public_path__ + "img/menu-24px.83790506.svg";